// Timeout in minutes to burst signed URLs cache
export const SIGNED_URLS_CACHE_TIMEOUT_VALUE = 30;

export const REALTIME_CONNECTION_TIMEOUT_VALUE = 200;
